var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #091430;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.7,23.2H24.9c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4h45.9c2.2,0,4,1.8,4,4h0c-.1,2.2-1.9,4-4.1,4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.7,42.9H24.9c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4h45.9c2.2,0,4,1.8,4,4h0c-.1,2.2-1.9,4-4.1,4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.7,62.6H24.9c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4h45.9c2.2,0,4,1.8,4,4h0c-.1,2.2-1.9,4-4.1,4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,23.2h-6.3c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4h6.3c2.2,0,4,1.8,4,4h0c0,2.2-1.7,4-4,4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,42.9h-6.3c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4h6.3c2.2,0,4,1.8,4,4h0c0,2.2-1.7,4-4,4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,62.6h-6.3c-2.2,0-4-1.8-4-4h0c0-2.2,1.8-4,4-4h6.3c2.2,0,4,1.8,4,4h0c0,2.2-1.7,4-4,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.16f951997a49da8538196e258404e3aa.svg";
export { ForwardRef as ReactComponent };